<template>
  <v-row no-gutters class="pt-1">
    <v-col cols="12">
      <v-card elevation="0" ma-0>
        <v-form v-model="valid" ref="collectedItemForm">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="collectedItem.customer"
                      item-text="customerName"
                      prepend-icon="person"
                      :items="customerList"
                      label="Payment By"
                      return-object
                      dense
                    ></v-autocomplete>
                  </v-col>
                   <v-col cols="12" md="6">
                    <v-menu
                      v-model="collectDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="collectedItem.collectDate"
                          label="Collect Date *"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          required
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="collectDate"
                        @input="collectDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="collectedItem.customerName"
                      label="Receiver Name"
                      prepend-icon="person"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="collectedItem.phone"
                      label="Phone No"
                      prepend-icon="phone"
                      required
                    />
                  </v-col>
                </v-row>

               

                <v-row>
                  <v-col cols="12">
                    <v-textarea
                      v-model="collectedItem.address"
                      label="Address"
                      dense
                      hide-details
                      rows="1"
                      prepend-icon="location_city"
                      required
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-row no-gutters>
                    <v-col cols="12" md="2" >
                      <v-btn  icon color="black" @click="clickLocationSave(collectedItem.custLocation)">
            <v-icon>save</v-icon></v-btn>
                      <v-btn  icon color="primary" @click="clickLocation(collectedItem.custLocation)">
            <v-icon>location_on</v-icon></v-btn>
                    </v-col>
                  <v-col cols="12" md="10">
                      <v-text-field v-model="collectedItem.custLocation"
                          label="Receiver Location"
                          required
                          dense></v-text-field>
                  </v-col>
                </v-row>
                  </v-col>
                  <v-row no-gutters class="pt-5">
                    <v-col cols="6" md="6">
                      <v-text-field
                        name="Cash"
                        v-model.number="collectedItem.customerPaid"
                        label="Cash"
                        prepend-icon="attach_money"
                        type="number"
                        dense
                      />
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-text-field
                        name="Kpay"
                        v-model.number="collectedItem.kpay"
                        label="Kpay"
                        prepend-icon="attach_money"
                        type="number"
                        dense
                      />
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-text-field
                        name="WavePay"
                        v-model.number="collectedItem.waypay"
                        label="WayPay"
                        prepend-icon="attach_money"
                        type="number"
                        dense
                      />
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-text-field
                        name="OtherPay"
                        v-model.number="collectedItem.otherpay"
                        label="OtherPay"
                        prepend-icon="attach_money"
                        type="number"
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="12" class="pl-5">
                      <span class="red--text"
                        ><h3>
                          Customer Pre Paid =
                          {{ totalCustomerPaid | defaultPaymentFormat }}
                        </h3></span
                      >
                    </v-col>
                  </v-row>
                </v-row>
                <v-row>
                  <v-col cols="3" md="3">
                    <v-chip color="primary" outlined class="mt-2"
                      >&nbsp;{{ status }}&nbsp;</v-chip
                    >
                    <!-- <v-btn
                      icon
                      text
                      color="primary"
                      outlined
                      class="ml-2 mt-2"
                      @click="clickPhoto()"
                    >
                      <v-icon>camera_enhance</v-icon>
                    </v-btn> -->
                  </v-col>

                  <v-col cols="5" md="5">
                    
              <v-text-field :rules="[v => v.length==6 || '']"
                :counter = 6
                maxlength="6" outlined @input="loadTime(tmptimeToDeliver)" v-model="tmptimeToDeliver" label="Time to Deliver" ></v-text-field>
            </v-col>
            <v-col cols="4" md="4" class="mt-4">
              <center><h2>{{collectedItem.timeToDeliver }}</h2></center>
            </v-col>

            

                  <!-- <v-col cols="6" md="6">
                    <v-menu
                      v-model="collectDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="collectedItem.collectDate"
                          label="Collect Date *"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                          required
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="collectDate"
                        @input="collectDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col> -->
                  <v-col cols="12" md="12">
                    <v-btn
                      color="primary"
                      outlined
                      class="ml-2"
                      @click="clickGateVoucher()"
                    >Gate Voucher
                    </v-btn>
                    <v-btn
                      color="primary"
                      outlined
                      class="ml-2 "
                      @click="clickItemSimple()"
                    >Item Simple
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="12">
                      <v-btn
              color="primary"
              v-if="collectedItem.transactionId == 0"
              @click="beforeSaveCollectedItem"
            >
              <v-icon>save</v-icon>Save
            </v-btn>
            <v-btn  color="primary" v-else @click="beforeUpdateCollectedItem">
              <v-icon>edit</v-icon>Update
            </v-btn>
            <v-btn
              color="accent"
              v-if="collectedItem.transactionId == 0"
              @click="printAndSaveVoucher"
              class="ml-3"
            >
              <v-icon>print</v-icon>Save & Print
            </v-btn>
            <v-btn class="ml-3" color="accent" v-else @click="printAndUpdateVoucher">
              <v-icon>print</v-icon>Update & Print
            </v-btn>
                    </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="7" offset-md="1">
                <!-- <v-row no-gutters>
                  <v-col cols="12" md="4"></v-col>
                  <v-col cols="12" md="4" offset-md="1"></v-col>
                </v-row> -->
                <v-row no-gutters>
                  <v-col cols="12" md="5">
                    <v-row no-gutters>
                      <v-col cols="12" md="12">
                    <v-autocomplete
                      v-model="selectedRestaurant"
                      item-text="restName"
                      prepend-icon="person"
                      :items="collectedItem.restList"
                      label="Restaurant Name"
                      autocomplete="off"
                      return-object
                      dense
                    ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row no-gutters>
                          <v-col cols="8" md="8">
                            <v-text-field
                              dense
                              name="itemNa123meitemName"
                              v-model="itemName"
                              label="Item Name *"
                              @keyup.enter="enterItemName()"
                              ref="itemNameRef"
                            />
                          </v-col>
                          <v-col cols="4" md="4" class="pl-3">
                            <v-text-field
                              dense
                              name="qtyqtu"
                              v-model.number="qty"
                              label="Qty*"
                              type="number"
                              @keyup.enter="enterQty()"
                              ref="qtyRef"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-simple-table
      :fixed-header="true" dense class="elevation-1" height="39vh">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center white--text primary">No.</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Item Name</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Qty</th>
            <th class="text-center white--text primary"><v-divider vertical></v-divider></th>
            <th class="text-center white--text primary">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr 
           v-for="(item,index) in selectedRestaurant.itemQtyList" :key="index" >
           <td class="text-center">{{ item.no }}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td>{{ item.itemName }}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td class="text-right">{{ item.qty}}</td>
            <td class="text-center"><v-divider vertical></v-divider></td>
            <td class="text-center">
              <v-btn small icon color="green" @click="clickEdit(item)">
            <v-icon>edit</v-icon></v-btn>
            <v-btn small icon color="red" @click="clickDelete(item)">
            <v-icon>delete</v-icon></v-btn>
            </td>
          </tr>
          <v-divider></v-divider>
        </tbody>
      </template>
 </v-simple-table>
                      </v-col>
                    </v-row>
                    <v-row no-gutters class="pt-4">
                      <v-col cols="6" md="6" >
                        <v-text-field
                          name="Rest Amount"
                          v-model.number="collectedItem.restAmount"
                          label="Rest Amount"
                          prepend-icon="restaurant_menu"
                          type="number"
                          dense
                        />
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-text-field
                          name="Rest Discount"
                          v-model.number="collectedItem.restDiscount"
                          label="Rest Discount"
                          prepend-icon="restaurant_menu"
                          type="number"
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="6" md="6">
                        <v-text-field
                          name="Rest Amount"
                          v-model.number="collectedItem.restDisAmount"
                          label="Rest DisAmount"
                          prepend-icon="restaurant_menu"
                          type="number"
                          dense
                          disabled
                        />
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-text-field
                          name="Rest Discount"
                          v-model.number="restTotalAmount"
                          label="Rest Total"
                          prepend-icon="restaurant_menu"
                          type="number"
                          dense
                          disabled
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col offset-md="1" cols="12" md="6">
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-row no-gutters>
                          <v-col cols="6" md="6">
                            <v-checkbox
                              v-model="collectedItem.disOrder"
                              label="OrderAmount"
                              hide-details
                            />
                          </v-col>
                          <v-col cols="6" md="6">
                            <v-checkbox
                              v-model="collectedItem.disDeli"
                              label="Service Charges"
                              hide-details
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-autocomplete
                      v-model="collectedItem.paymentType"
                      item-text="restName"
                      prepend-icon="attach_money"
                      :items="paymentList"
                      label="Payment Type"
                      autocomplete="off"
                      return-object
                      dense
                    ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-fade-transition>
                          <v-text-field
                            name="paid"
                            v-model.number="collectedItem.paid"
                            label="Credit/Prepaid"
                            prepend-icon="attach_money"
                            type="number"
                            dense
                          />
                        </v-fade-transition>
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-fade-transition>
                          <v-text-field
                            name="OrderAmount"
                            v-model.number="collectedItem.itemValue"
                            label="Order Amount"
                            prepend-icon="attach_money"
                            type="number"
                            :rules="itemValue"
                            dense
                          />
                        </v-fade-transition>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          name="tocollect"
                          v-model.number="collectedItem.tocollect"
                          label="To Collect"
                          prepend-icon="attach_money"
                          type="number"
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6" md="6">
                        <v-text-field
                          name="amount"
                          v-model.number="collectedItem.amount"
                          label="Service Charges *"
                          prepend-icon="attach_money"
                          type="number"
                          :rules="amountRule"
                          dense
                        />
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-text-field
                          name="Discounta"
                          v-model.number="collectedItem.disPercent"
                          label="Discount(%)"
                          prepend-icon="attach_money"
                          type="number"
                          dense
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- <v-col cols="6" md="6">
                        <v-fade-transition>
                          <v-text-field
                            name="customerpaiddd"
                            v-model.number="collectedItem.customerPaid"
                            label="Customer Paid"
                            prepend-icon="attach_money"
                            type="number"
                            :rules="[checkValue]"
                            dense
                          />
                        </v-fade-transition>
                      </v-col> -->
                      <v-col cols="6" md="6">
                        <v-text-field
                          name="extraweight"
                          v-model.number="collectedItem.extraWeight"
                          label="extra Weight"
                          prepend-icon="attach_money"
                          type="number"
                          dense
                        />
                      </v-col>
                      <v-col cols="6" md="6">
                        <v-fade-transition>
                          <v-text-field
                            name="totaldisamount"
                            v-model.number="collectedItem.discount"
                            label="Discount Amount"
                            prepend-icon="attach_money"
                            type="number"
                            disabled
                            dense
                          />
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="12" md="6" class="mb-3">
                        <span class="blue--text"
                          ><h3>
                            Total Charges =
                            {{ totalAmount | defaultPaymentFormat }}
                          </h3></span
                        >
                      </v-col>
                    </v-row>
                    <v-textarea
                      dense
                      name="remark"
                      v-model="collectedItem.remark"
                      label="Remark"
                      rows="2"
                      prepend-icon="description"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-card>
    </v-col>
    <v-dialog v-model="barCodeDialog" width="450">
      <v-card>
        <v-card-title class="headline" primary-title dark
          >Scan QR Code</v-card-title
        >
        <v-card-text>
          <v-row no-gutters>
            <v-col>
              <barcode-scanview
                :dialogStatus="barCodeDialog"
                :barCodeReceive="barCodeReceive"
                :outsideBarCode="outsideBarCode"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPayment"
      persistent
      max-width="400"
      transition="dialog-bottom-transition"
    >
      <paymentDialog @closeDialog="dialogPayment = false" :itemId="itemId" :photoIndex="photoIndex"/>
    </v-dialog>
    <v-dialog
      v-model="dialogDelete"
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h5">
          Do you want to delete?
        </v-card-title>
        <v-card-text>{{saveOrupdateIndex}} - {{deleteItemName}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="clickDeleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { isNumber } from "util";
import { allowedDate } from "../utils";
import customerService from "../service/CustomerService";
import BarCodeScanView from "../components/BarCodeScanView";
import paymentDialog from "@/components/PaymentPhotoDialog.vue";
import onlineshoppingService from "../service/OnlineshoppingService";
export default {
  mounted: function () {
    this.getCustomerList();
    // townshipService.getAllCity().then((data) => {
    //   this.listCity = this.listCity.filter((v) => false);
    //   this.listCity.push(...data);
    // });
  },
  data: () => {
    return {
      valid: false,
      customerList: [],
      loading: false,
      search: null,
      itemNameRule: [(v) => !!v || "ItemName is required"],

      amountRule: [
        (v) => v > -1 || "Amount less than zero",
        (v) => isNumber(v) || "Amount is require",
      ],
      itemValue: [
        (v) => v > -1 || "Item Value less than zero",
        (v) => isNumber(v) || "ItemValue is require",
      ],
      collectDateMenu: false,
      nameRule: [(v) => !!v || "Name is required"],
      phoneRule: [(v) => !!v || "Phone No is required"],
      addressRule: [(v) => !!v || "Address is required"],
      townshipRule: [(v) => !!v || "Township is required"],
      cityRule: [(v) => !!v || "City is required"],
      barCodeDialog: false,
      outsideBarCode: true,
      listCity: [],
      listTownship: [],
      dialogPayment: false,
      totalAmount: 0,
      totalCustomerPaid: 0,
      restTotalAmount: 0,
      itemName:"",
      qty:0,
      itemNameIndex:0,
      saveOrupdateIndex:0,
      dialogDelete:false,
      deleteItemName:"",
      photoIndex:"",
      selectedRestaurant:{},
      refreshOrderAmount:0,
      paymentList:["COD","CREDIT","PREPAID"],
      tmptimeToDeliver:"",
      isloadTime:true,
    };
  },
  props: {
    collectedItem: {
      itemId: {
        type: Number,
        default: 0,
      },
      encryptedCode: {
        type: String,
        default: "",
      },
      itemName: {
        type: String,
        default: "",
      },
      weight: {
        type: String,
        default: "",
      },
      osPayment: {
        type: Boolean,
        default: false,
      },
      customerPayment: {
        type: Boolean,
        default: false,
      },
      advancePaid: {
        type: Number,
        default: 0,
      },
      remark: {
        type: String,
        default: "",
      },
      transactionId: {
        type: Number,
        default: 0,
      },
      amount: {
        type: Number,
        default: 0,
      },
      itemValue: {
        type: Number,
        default: 0,
      },
      fromOSId: {
        type: Number,
        default: 0,
      },
      collectDate: {
        type: String,
        default: "",
      },
      date: {
        type: String,
        default: "",
      },
      modifiedDate: {
        type: String,
        default: "",
      },
      customerName: {
        type: String,
        default: 0,
      },
      address: {
        type: String,
        default: 0,
      },
      phone: {
        type: String,
        default: "",
      },
      code: {
        type: String,
        default: "",
      },
      cityId: {
        type: Number,
        default: 0,
      },
      townshipId: {
        type: Number,
        default: 0,
      }
    },
    status: String,
    itemId: Number,
    loadCollectedItem: Function,
    saveCollectedItem: Function,
    updateCollectedItem: Function,
  },
  methods: {
    clickLocationSave:function(latitude){
      onlineshoppingService
          .getOsLocation(this.collectedItem.customer.customerId,latitude)
          .then(() => {
            this.$swal({
     title: "Successful",
     text: "Onlineshopping Successful!",
     type: "success",
     timer: 500
     });
          })
          .catch(err => {
              this.$swal("Failed", err.response.data.message, "error");
          });
    },
    clickLocation:function(item){
        window.open(item, "_blank");
    },
    clickDeleteItem:function(){
    var tempList = [];
    tempList.push(...this.selectedRestaurant.itemQtyList);
    this.selectedRestaurant.itemQtyList.splice(0);
    var no = 0;
    for(var i=0;i<tempList.length;i++){
      var tempObj = tempList[i];
      if(tempObj.no!=this.saveOrupdateIndex){
          no = no+1;
          tempObj.no = no;
          this.selectedRestaurant.itemQtyList.push(tempObj);
      }
    }
    this.saveOrupdateIndex = 0;
    this.itemNameIndex = this.selectedRestaurant.itemQtyList.length;
    this.dialogDelete = false;
    },
    clickDelete:function(item){
          this.dialogDelete = true;
          this.deleteItemName = item.itemName;
          this.saveOrupdateIndex = item.no;
        },
    clickEdit:function(item){
      this.saveOrupdateIndex = item.no;
      this.itemName = item.itemName;
      this.qty = item.qty;
      this.$nextTick(() => this.$refs.itemNameRef.focus());
    },
    enterItemName:function(){
          this.$nextTick(() => this.$refs.qtyRef.focus());
    },
    enterQty:function(){
      if(this.saveOrupdateIndex==0){
      this.itemNameIndex = Number(this.itemNameIndex)+1;
      this.$nextTick(() => this.$refs.itemNameRef.focus());
      var itemObj = {};
      itemObj.no = this.itemNameIndex;
      itemObj.itemName = this.itemName;
      itemObj.qty = Number(this.qty);
      this.selectedRestaurant.itemQtyList.push(itemObj);
      }else{
        var tempRecipes = this.selectedRestaurant.itemQtyList.find((item) => {
      return (item.no == this.saveOrupdateIndex)
    });
    tempRecipes.itemName = this.itemName;
      tempRecipes.qty = this.qty;
      }
      this.saveOrupdateIndex = 0;
      this.itemName = "";
      this.qty = 0;
    },
    checkValue: function (v) {
      let result = v > -1 || "Paid less than zero";
      if (result == true) {
        result = isNumber(v) || "Paid is require";

        if (result == true) {
          if (v != 0) {
            result =
              v <= this.totalAmount ||
              "Customer Paid should be equal with Customer Payment Or Zero";
          }

          return result;
        } else {
          return true;
        }
      }
      return result;
    },
    clickPhoto: function () {
      this.dialogPayment = true;
      this.photoIndex = "item";
    },
    clickGateVoucher: function () {
      this.dialogPayment = true;
      this.photoIndex = "gate";
    },
    clickItemSimple: function () {
      this.dialogPayment = true;
      this.photoIndex = "simple";
    },
    printPreview: function () {
      this.$router
        .push({
          name: "voucherPrint",
          query: {
            itemId: this.itemId,
          },
        })
        .catch(() => {});
    },
    printAndSaveVoucher: function () {
      this.saveCollectedItem(true);
    },
    printAndUpdateVoucher: function () {
      this.$refs.collectedItemForm.validate();
      if (this.valid) {
        this.updateCollectedItem(true);
      }
    },
    getCustomerList: function () {
      customerService.getcustomers().then((response) => {
        this.customerList.splice(0, this.customerList.length);
        this.customerList.push(...response);
      });
    },
    beforeSaveCollectedItem: function () {
      this.$refs.collectedItemForm.validate();
      if (this.valid) {
        this.saveCollectedItem();
      }
    },
    beforeUpdateCollectedItem: function () {
      if (
        "DELIVERED" != this.status &&
        "COMPLETED" != this.status &&
        "ERROR" != this.status &&
        "RETURN" != this.status
      ) {
        this.$refs.collectedItemForm.validate();
        if (this.valid) {
         // var itemName = "";
        // for(var i=0;i<this.selectedRestaurant.itemQtyList.length;i++){
        //     var tempObj = this.selectedRestaurant.itemQtyList[i];
        //     if(i==0){
        //         itemName = tempObj.itemName+" - "+tempObj.qty;
        //     }else{
        //         itemName = itemName+","+tempObj.itemName+" - "+tempObj.qty;
        //     }
            
        // }
        //this.collectedItem.itemName = itemName;
          //this.$store.commit("addItem", this.collectedItem.itemName);
          this.updateCollectedItem();
        }
      } else {
        this.$swal(
          "Status ကို Assigned အရင်ပြောင်းပေးပါ",
          "(5)Payment ကို နှိပ်ပြီး Status ကို တစ်ခုခု ပြောင်းပေးပါ၊ ပြီးမှ ပြင်လို့ ရပါမည်၊",
          "error"
        );
      }
    },
    allowedDate: allowedDate,
    scanBarcode: function () {
      this.barCodeDialog = true;
    },
    barCodeReceive: function (id) {
      this.collectedItem.code = id;
      this.barCodeDialog = false;
    },
    loadTime:function(timeToDeliver){
        this.isloadTime = false;
        this.collectedItem.timeToDeliver = this.splitTime(timeToDeliver);
    },
    splitTime(time) {
      var realTime = "";
      var realAmPm = "";
      if(time!=undefined){
      if(time.length==6){
        var tempTest = this.testingTimeWord(time,realTime);
        if("error" == tempTest){
          return "error";
        }
      for(var i=0;i<time.length;i+=2){
        realTime = realTime+time[i]+time[i+1];
        if(i<3){
          if(i==0){
            var ampm = Number(realTime);
            if(realTime>=12 && realTime<24){
              realAmPm = "PM";
              if(realTime>12){
                realTime = realTime-12;
                if(realTime<10){
                  realTime = "0"+realTime;
                }
              }
            }else{
              realAmPm = "AM";
              if(realTime==24){
                realTime = 12;
              }
            }
          }
          realTime = realTime+":";
        }
        
      }
      realTime = realTime+" "+realAmPm;
      }else{
        realTime = this.testingTimeWord(time,realTime);
      }
      }else{
        realTime = "";
      }
      return realTime;
    },
    testingTimeWord(time,realTime){
      var tiemlength = time.length;
      if(tiemlength==1){
          if(Number(time)>2){
            realTime = "error";
          }
        }else if(tiemlength==2){
          if(Number(time)>24){
            realTime = "error";
          }
        }else if(tiemlength==3){
          var hour = time.substr(0,2);
          var temp = time.substr(2,2);
          if(Number(temp)>5||Number(hour)>24){
              realTime = "error";
          }
        }else if(tiemlength==4){
          var hour = time.substr(0,2);
          var temp = time.substr(2,2);
          if(Number(temp)>59||Number(hour)>24){
              realTime = "error";
          }
        }else if(tiemlength==5){
          var hour = time.substr(0,2);
          var minute = time.substr(2,2);
          var temp = time.substr(4,2);
          if(Number(temp)>5||Number(minute)>59||Number(hour)>24){
              realTime = "error";
          }
        }else if(tiemlength==6){
          var hour = time.substr(0,2);
          var minute = time.substr(2,2);
          var temp = time.substr(4,2);
          if(Number(temp)>59||Number(minute)>59||Number(hour)>24){
              realTime = "error";
          }
        }
        return realTime;
    }
  },
  computed: {
    collectDate: {
      set(value) {
        this.collectedItem.collectDate = this.$moment(
          this.$moment(value, "YYYY-MM-DD")
        ).format("DD-MM-YYYY");
      },
      get() {
        if (
          this.collectedItem != null &&
          this.collectedItem.collectDate == ""
        ) {
          return this.collectedItem.collectDate;
        }
        return this.$moment(
          this.$moment(this.collectedItem.collectDate, "DD-MM-YYYY")
        ).format("YYYY-MM-DD");
      },
    },
    itemList: function () {
      let result = [];
      //result.push(...new Set(this.$store.state.itemList));
      return result;
    },
  },
  components: {
    "barcode-scanview": BarCodeScanView,
    paymentDialog,
  },
  watch: {
    selectedRestaurant:function(){
      this.itemNameIndex = this.selectedRestaurant.itemQtyList.length;
      this.collectedItem.restAmount = this.selectedRestaurant.restAmount;
      this.collectedItem.restDiscount = this.selectedRestaurant.restDiscount;
      this.collectedItem.restDisAmount = this.selectedRestaurant.restDisAmount;
    },
    collectedItem:function(){
        this.selectedRestaurant = this.collectedItem.restList[0];
    },
    "collectedItem.customer": function (v) {
      if(v.address!=undefined){
      if (v != undefined) {
        this.collectedItem.customerName = v.customerName;
        this.collectedItem.address = v.address;
        this.collectedItem.phone = v.phone;
        this.collectedItem.custLocation = v.latitude;
      } else {
        this.collectedItem.customerName = null;
        this.collectedItem.address = null;
        this.collectedItem.phone = null;
      }
      }
    },
    // "collectedItem.itemId": function () {
    //   this.loadCollectedItem();
    // },
    "collectedItem.itemValue": function () {
      if (this.collectedItem.disOrder) {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
    "collectedItem.tocollect": function () {
      if (this.collectedItem.disOrder) {
        this.collectedItem.discount = 
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
    "collectedItem.disPercent": function () {
      if (this.collectedItem.disOrder) {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
    "collectedItem.paid": function () {
      if (this.collectedItem.disOrder) {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
      
    },
    "collectedItem.amount": function () {
      if (this.collectedItem.disOrder) {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
    "collectedItem.extraWeight": function () {
      if (this.collectedItem.disOrder) {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
    "collectedItem.customerPaid": function () {
      this.totalCustomerPaid =
        this.collectedItem.customerPaid +
        this.collectedItem.kpay +
        this.collectedItem.waypay +
        this.collectedItem.otherpay;
    },
    "collectedItem.kpay": function () {
      this.totalCustomerPaid =
        this.collectedItem.customerPaid +
        this.collectedItem.kpay +
        this.collectedItem.waypay +
        this.collectedItem.otherpay;
    },
    "collectedItem.waypay": function () {
      this.totalCustomerPaid =
        this.collectedItem.customerPaid +
        this.collectedItem.kpay +
        this.collectedItem.waypay +
        this.collectedItem.otherpay;
    },
    "collectedItem.otherpay": function () {
      this.totalCustomerPaid =
        this.collectedItem.customerPaid +
        this.collectedItem.kpay +
        this.collectedItem.waypay +
        this.collectedItem.otherpay;
    },
    "collectedItem.restAmount": function () {
      this.collectedItem.restDisAmount =
        (Number(this.collectedItem.restAmount) *
          Number(this.collectedItem.restDiscount)) /
        100;
      this.restTotalAmount =
        Number(this.collectedItem.restAmount) -
        Number(this.collectedItem.restDisAmount);

        this.selectedRestaurant.restAmount = this.collectedItem.restAmount;
        if(this.refreshOrderAmount!=0){
        var totalOrderAmount = 0;
        for(var i=0;i<this.collectedItem.restList.length;i++){
            var tempObj = this.collectedItem.restList[i];
            totalOrderAmount = Number(totalOrderAmount)+Number(tempObj.restAmount);
        }
          this.collectedItem.itemValue = totalOrderAmount;
        }else{
          this.refreshOrderAmount = 1;
        }
    },
    "collectedItem.restDiscount": function () {
      this.collectedItem.restDisAmount =
        (Number(this.collectedItem.restAmount) *
          Number(this.collectedItem.restDiscount)) /
        100;
         this.selectedRestaurant.restDiscount = this.collectedItem.restDiscount;
    },
    "collectedItem.restDisAmount": function () {
      this.restTotalAmount =
        Number(this.collectedItem.restAmount) -
        Number(this.collectedItem.restDisAmount);
        this.selectedRestaurant.restDisAmount = this.collectedItem.restDisAmount;
    },
    "collectedItem.timeToDeliver": function () {
      if(this.isloadTime){
if(this.collectedItem.timeToDeliver!=undefined){
          this.tmptimeToDeliver = this.collectedItem.timeToDeliver.substr(0,8).replaceAll(":","");
           let tempAmPm = this.collectedItem.timeToDeliver.substr(8,3).trim();
           if(tempAmPm=="PM"){
            tempAmPm = this.collectedItem.timeToDeliver.substr(0,2).trim();
            let hours = Number(tempAmPm)+12;
            let minutesSecond = this.tmptimeToDeliver.substr(2,4);
            console.log()
            this.tmptimeToDeliver = hours+""+minutesSecond;
           }
        }
         this.isloadTime = false;
      }else{
        this.isloadTime = false;
      }
    },
    //collectedItem.restAmount
    // "collectedItem.cityId": function (value, oldValue) {
    //   if (oldValue == undefined) {
    //   } else {
    //     this.collectedItem.townshipId = 0;
    //   }
    //   if (value != undefined && value != 0) {
    //     townshipService.getTownshipByCityId(value).then((data) => {
    //       this.listTownship = this.listTownship.filter((v) => false);
    //       this.listTownship.push(...data);
    //     });
    //   }
    // },
    // "collectedItem.townshipId": function (value) {
    //   for (var i = 0; i < this.listTownship.length; i++) {
    //     var ts = this.listTownship[i];
    //     if (ts.townshipId == value) {
    //       this.collectedItem.amount = ts.tsAmount;
    //     }
    //   }
    // },
    "collectedItem.disOrder": function (value) {
      if (value) {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
        this.collectedItem.disDeli = !value;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
        this.collectedItem.disDeli = !value;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
    "collectedItem.disDeli": function (value) {
      if (value) {
        this.collectedItem.discount =
          (Number(this.collectedItem.amount) *
            Number(this.collectedItem.disPercent)) /
          100;
        this.collectedItem.disOrder = !value;
      } else {
        this.collectedItem.discount =
          (Number(this.collectedItem.itemValue) *
            Number(this.collectedItem.disPercent)) /
          100;
        this.collectedItem.disOrder = !value;
      }
        this.totalAmount =
      Number(this.collectedItem.tocollect) +
        Number(this.collectedItem.itemValue) +
        Number(this.collectedItem.amount) +
        Number(this.collectedItem.extraWeight) -
        Number(this.collectedItem.paid) -
        Number(this.collectedItem.discount);
    },
     "collectedItem.paymentType":function(value,oldValue){
      if(value!='COD'){
        if(oldValue=='COD')
          this.collectedItem.paid = this.totalAmount;
     }else{
        this.collectedItem.paid = Number(0);
      }
     }

  },
};
</script>
<style scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 0px !important;
}
</style>